export default __webpack_public_path__ + "static/media/Screenshot_10.8b955730.png";